import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { useListReferencePeriodsQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'StandardReferencePeriodSelect',
  setup: function setup(__props) {
    var _useListReferencePeri = useListReferencePeriodsQuery({
        filters: {
          userDefined: false
        },
        sort: 'asc'
      }),
      result = _useListReferencePeri.result;
    var standardReferencePeriods = computed(function () {
      var _result$value$listRef, _result$value, _result$value$listRef2;
      return (_result$value$listRef = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : (_result$value$listRef2 = _result$value.listReferencePeriods) === null || _result$value$listRef2 === void 0 ? void 0 : _result$value$listRef2.filter(function (period) {
        return period.label !== null;
      })) !== null && _result$value$listRef !== void 0 ? _result$value$listRef : [];
    });
    return {
      __sfc: true,
      result: result,
      standardReferencePeriods: standardReferencePeriods
    };
  }
});